<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-title class="mb-1">
          Jumlah Konsultasi dan Status Pengerjaan Selesai
        </b-card-title>
        <b-card-sub-title>Konsultasi x Selesai</b-card-sub-title>
      </div>
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        type="area"
        height="400"
        :options="lineAreaChartSpline.chartOptions"
        :series="lineAreaChartSpline.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BCardSubTitle,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    // BRow,
    // BCol,
    BCard,
    BCardHeader,
    BCardSubTitle,
    BCardTitle,
    // BCardText,
    BCardBody,
    // BMedia,
    // BAvatar,
    // BMediaAside,
    // BMediaBody,
    VueApexCharts,
    // flatPickr,
  },
  props: {
    rangePicker: {},
    lineAreaChartSpline: {},
  },
}
</script>
